export const ELEMENT_TYPE_ZH = {
  text: 'Text',
  html: 'Html',
  image: 'Image',
  shape: 'Shape',
  line: 'Line',
  chart: 'Chart',
  table: 'Table',
  video: 'Video',
  audio: 'Audio',
  latex: 'Latex',
  dragdrop: 'Drag n Drop',
  slidelayout: 'Slide Layout',
  section: 'Section Container'
}

export const MIN_SIZE = {
  text: 20,
  image: 20,
  shape: 15,
  chart: 200,
  table: 20,
  video: 250,
  audio: 20,
  latex: 20,
}
